import { render, staticRenderFns } from "./requestor-companies.vue?vue&type=template&id=8ff5afb2&"
import script from "./requestor-companies.vue?vue&type=script&lang=js&"
export * from "./requestor-companies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports